function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { useRef } from 'react';
export function useIdempotencyKey() {
  var keyRef = useRef(typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : "".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2)));
  return keyRef.current;
}

/**
 * Extracts a structured error from an ErrorEnvelope response.
 *
 * Contract shape (bafkal.yaml → ErrorEnvelope):
 *   { code, message, details, requestId, timestamp }
 *
 * Returns a plain object with the fields the UI cares about.
 * Falls back to a generic message if the response is not an ErrorEnvelope.
 */
export var extractContractError = function extractContractError(err) {
  var _err$response;
  var fallbackMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'An unexpected error occurred';
  var data = err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.data;
  if (data && _typeof(data) === 'object' && (data.code || data.message)) {
    return {
      code: data.code || 'UNKNOWN',
      message: data.message || fallbackMessage,
      requestId: data.requestId || null
    };
  }
  return {
    code: 'UNKNOWN',
    message: (err === null || err === void 0 ? void 0 : err.message) || fallbackMessage,
    requestId: null
  };
};

/**
 * Formats an error for display in the UI.
 * Shows the message; appends the requestId in development for traceability.
 */
export var formatErrorForDisplay = function formatErrorForDisplay(contractError) {
  var isDev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isDev && contractError.requestId) {
    return "".concat(contractError.message, " (requestId: ").concat(contractError.requestId, ")");
  }
  return contractError.message;
};